export var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v1"] = "v1";
    ApiVersion["v2"] = "v2";
})(ApiVersion || (ApiVersion = {}));
//# sourceMappingURL=ApiVersion.js.map